import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CircularIndicatorComponent } from './components/circular-indicator/circular-indicator.component';
@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    CircularIndicatorComponent,
  ],
  exports: [
    TranslateModule,
    ReactiveFormsModule,
    CircularIndicatorComponent,
  ]
})
export class SharedModuleLib {}
